/*
 * File: Appointments.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the Patient Appointment & Follow Ups view
 */
import React from "react";
import AppointmentLinks from "./AppointmentLinks";
import NewAppointmentFabButton from "./NewAppointmentFabButton";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "services/patients/topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-2.5),
    marginTop: theme.spacing(2.5)
  }
});

const Appointments = ({ classes, history }) => {
  return (
    <div className="gradient">
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader
          pageTitle="Appointments & Follow-Ups"
          pageSubtitle="Patient"
        />
      </Toolbar>
      <AppointmentLinks />
      <NewAppointmentFabButton history={history} />
    </div>
  );
};

Appointments.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired //this is used in NewAppointmentFabButton.js
};

export default withStyles(styles)(Appointments);
